<template>
  <div id="manifest-list">
    <b-container>
      <b-row>
        <b-col>
          <h2 v-translate>Ongoing Manifests</h2>
        </b-col>
        <b-col v-if="storesSelect.length > 0">
          <h4 v-translate>Filter by stores</h4>
          <b-row>
            <b-col cols="6">
              <b-form-select v-model="restrictToStoreFrom" :options="storesSelect" class="mb-3 form-control" @change="fetchManifests();">
                <template slot="first">
                  <option :value="null" v-translate>All stores</option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div v-if="isLoading" class="manifest-preview">
        <!-- Loading manifests... -->
      </div>
      <div v-else>
        <b-row v-if="manifests && manifests.length > 0">
          <b-col cols="12" md="6" lg="4" v-for="(manifest, index) in manifests" :key="index">
            <router-link :to="{ name: 'manifests-item', params: {'id': manifest.id} }" class="preview-link">
              <b-card class="manifest-item">
                <h4 v-translate="{route: $options.filters.uuid(manifest.id)}">Route: #%{route}</h4>
                <hr>
                <h5 v-translate="{shippingsQty: manifest.shippings.length}" :translate-n="manifest.shippings.length" translate-plural="<strong>%{shippingsQty}</strong> shippings">%{shippingsQty} shipping</h5>
                <hr>
                <b-row v-if="manifest.courier">
                  <b-col cols="3">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle profile-image" alt="img" :style="'width: 100%; height: auto; background-image: url(' + (manifest.courier.profile_picture || 'https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm') + ')'" />
                  </b-col>
                  <b-col class="align-self-center">
                    <h5>{{manifest.courier.name}} <small v-if="manifest.courier.tin"><small>({{ manifest.courier.tin }})</small></small></h5>
                    <strong class="plate" v-if="manifest.courier.courier_available && manifest.courier.courier_available.vehicle && manifest.courier.courier_available.vehicle.plate_number">{{ manifest.courier.courier_available.vehicle.plate_number }}</strong>
                  </b-col>
                </b-row>
                <b-row v-else>
                  <b-col cols="3">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle profile-image" alt="img" style="width: 100%; height: auto; background-image: url(https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm)" />
                  </b-col>
                  <b-col class="align-self-center">
                    <h5 v-translate>Not assigned yet</h5>
                  </b-col>
                </b-row>
              </b-card>
            </router-link>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="12" v-translate>
            There are no manifests ongoing right now.
          </b-col>
        </b-row>
      </div>
    </b-container>
    <spinner />
  </div>
</template>
<script>
import Spinner from '@/components/Spinner'

export default {
  name: 'ManifestList',
  components: {
    Spinner
  },
  data() {
    return {
      manifests: [],
      hasLoaded: false,
      isLoading: false,
      interval: null,
      restrictToStoreFrom: null
    }
  },
  computed: {
    storesSelect() {
      return this.$store.getters.profile.company.stores ? this.$store.getters.profile.company.stores.map(x => { return {text: x.reference, value: x.place_id} }) : []
    }
  },
  mounted() {
    this.interval = setInterval(function () {
      this.fetchManifests()
    }.bind(this), 30000)
    this.fetchManifests()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    fetchManifests() {
      if (!this.hasLoaded) {
        this.$store.state.dashboard.isLoading = true
      }
      let params = {
        includes: ['shippings', 'courier.courier_available.vehicle'],
        sort: [
          {
            key: 'updated_at',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            filters: [
              ['courier_id', 'eq', 'null', 'true']
            ]
          }
        ]
      }
      if (this.restrictToStoreFrom) {
        params.filter_groups.push({
          filters: [
            ['shippings.from_place_id', 'eq', this.restrictToStoreFrom]
          ]
        })
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company.id + '/tours', {params: params})
        .then(response => {
          let manifests = response.body.data

          params.filter_groups = [
            {
              filters: [
                ['courier_id', 'eq', 'null']
              ]
            }
          ]
          if (this.restrictToStoreFrom) {
            params.filter_groups.push({
              filters: [
                ['shippings.from_place_id', 'eq', this.restrictToStoreFrom]
              ]
            })
          }
          this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company.id + '/tours', {params: params})
            .then(response => {
              this.manifests = manifests.concat(response.body.data)
              if (!this.hasLoaded) {
                this.$store.state.dashboard.isLoading = false
              }
              this.hasLoaded = true
            })
        })
    }
  }
}

</script>
<style lang="scss">
a {
  .manifest-item.card {
    transition: all 0.25s ease-in-out;
    box-shadow: 0 30px 100px 0 rgba(0, 0, 0, 0.15), 0 0 0 rgba(0, 0, 0, 0) !important;
  }

  &:hover {
    .manifest-item.card {
      box-shadow: 0 30px 100px 0 rgba(0, 0, 0, 0.15), 0 0 5px rgba(0, 0, 0, .2) !important;
    }
  }
}

.faq-item {
  h4 {
    color: #4fa0ff
  }
}

.author-text {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  margin: 0 -1em;
  padding: 1em 0.5em 0.25em 0.5em;

  .author-image {
    max-height: 30px;
    display: inline-block;
    border-radius: 4px;
    border: 2px solid white;
  }
}

</style>
